<template>
    <div class="popup mobile-popup" type="searchProduct" size="big">
        <div class="popup-header">
            <h1>Поиск товара</h1>
            <div class="close" @click="$emit('closePopup')"></div>
        </div>
        <Component class="popup-content" :is="contentScroll">
            <div class="popup-inner">
                <div class="search-product-tabs">
                    <div class="tab" :class="{ active: activeTab === 'product' }" @click="activeTab = 'product'">1. Выберите товар</div>
                    <div class="tab" :class="{ active: activeTab === 'series', disabled: !selectedProduct  }" @click="selectedProduct && (activeTab = 'series')">2. Выберите серию</div>
                </div>

                <div v-if="activeTab === 'product'" class="search-product-tab-content">
                    <p class="search-product-hint">Для выбора воспользуйтесь поиском. Если Вы не смогли найти нужный Вам товар, обратитесь к Вашему менеджеру.</p>
                    <div class="inline mob-col" valign="bottom" halign="start">
                        <div class="form-item" size="medium">
                            <input id="product_search" type="text" class="text-input" v-model.trim="productSearch" @keyup.enter="searchProducts" placeholder=" " />
                            <label for="product_search">Поиск</label>
                        </div>
                        <div class="form-item" size="medium">
                            <input id="manufacturer_filter" type="text" class="text-input" v-model.trim="manufacturerFilter" @keyup.enter="searchProducts" placeholder=" " />
                            <label for="manufacturer_filter">Производитель</label>
                        </div>
                        <div class="button" type="confirm" :class="{disabled: products.status == 'loading'}" @click="searchProducts">Найти</div>
                    </div>
                    <div class="table search-product-table">
                        <strong class="loading" v-if="products.status == 'loading' && !products.list.length">Поиск товаров</strong>
                        <div v-else>
                            <div v-if="!products.list.length">
                                <strong class="no-items">Товары не найдены</strong>
                            </div>
                            <table v-else>
                                <thead>
                                    <tr>
                                        <td>НАИМЕНОВАНИЕ</td>
                                        <td>ПРОИЗВОДИТЕЛЬ</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, key) in products.list" :key="key" :class="{ active: selectedProduct && selectedProduct.productCode === item.productCode }" @click="selectProduct(item)">
                                        <td>{{ item.productName }}</td>
                                        <td>{{ item.manufacturer }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div v-else class="search-product-tab-content">
                    <p class="search-product-hint">Серия указана на упаковке (6-8 цифр). Если Вы не смогли найти нужный Вам товар, обратитесь к Вашему менеджеру.</p>
                    <div v-if="selectedProduct" class="search-product-selected">
                        <div class="claim-text"><span>Наименование:</span> <strong>{{ selectedProduct.productName }}</strong></div>
                        <div class="claim-text"><span>Производитель:</span> <strong>{{ selectedProduct.manufacturer }}</strong></div>
                    </div>
                    <div class="inline mob-col" valign="bottom" halign="start">
                        <div class="form-item" size="medium">
                            <input id="series_search" type="text" class="text-input" v-model.trim="seriesSearch" @keyup.enter="searchSeries" placeholder=" " />
                            <label for="series_search">Поиск серии</label>
                        </div>
                        <div class="button" type="confirm" :class="{disabled: series.status == 'loading'}" @click="searchSeries">Найти</div>
                    </div>
                    <div class="table search-product-table">
                        <strong class="loading" v-if="series.status == 'loading' && !series.list.length">Поиск серий</strong>
                        <div v-else>
                            <div v-if="!series.list.length">
                                <strong class="no-items">Серии не найдены</strong>
                            </div>
                            <table v-else>
                                <thead>
                                    <tr>
                                        <td>СЕРИЯ</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, key) in series.list" :key="key" :class="{ active: selectedSeries && selectedSeries.seriesNumber === item.seriesNumber }" @click="selectSeries(item)">
                                        <td>{{ item.seriesNumber }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Component>
        <div class="search-product-footer">
            <template v-if="activeTab === 'product'">
                <p class="search-product-summary">Найдено {{ products.totalCount }} товаров. {{ selectedProduct ? 'Выбран: ' + selectedProduct.productName : 'Из них выбрано: 0' }}</p>
                <div class="search-product-actions">
                    <div class="button" type="decline" @click="$emit('closePopup')">Отмена</div>
                    <div class="button" type="confirm" :class="{disabled: !selectedProduct}" @click="goToSeries">Далее</div>
                </div>
            </template>
            <template v-else>
                <p class="search-product-summary">Найдено серий: {{ series.list.length }}</p>
                <div class="search-product-actions">
                    <div class="button" type="decline" @click="activeTab = 'product'">Назад</div>
                    <div class="button" type="confirm" :class="{disabled: !selectedSeries}" @click="confirmSelection">Выбрать</div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import SmoothScrollbar from '@/components/_smoothScrollbar.vue'

export default {
    props: ['contentScroll', 'activePopup'],
    data () {
        return {
            activeTab: 'product',
            productSearch: '',
            manufacturerFilter: '',
            seriesSearch: '',
            selectedProduct: null,
            selectedSeries: null,
            products: {
                status: '',
                list: [],
                totalCount: 0
            },
            series: {
                status: '',
                list: []
            }
        }
    },
    components: {
        SmoothScrollbar
    },
    computed: {
        clientId () {
            return this.$store.state.common.client.id
        },
        orderCode () {
            return (this.activePopup && this.activePopup.orderCode) || null
        }
    },
    methods: {
        searchProducts () {
            if (this.products.status === 'loading') return
            this.products.status = 'loading'
            const data = {
                clientId: this.clientId,
                productName: this.productSearch || null,
                manufacturer: this.manufacturerFilter || null,
                orderCode: this.orderCode,
                page: 1,
                itemsPerPage: 20
            }
            this.axios({url: 'api/v1/claim/searchproductsforclaim', data: data, method: 'POST'})
                .then(resp => {
                    this.products.status = ''
                    this.products.list = resp.data.products || []
                    this.products.totalCount = resp.data.totalCount || 0
                }).catch(() => {
                    this.products.status = ''
                })
        },
        searchSeries () {
            if (!this.selectedProduct) return
            if (this.series.status === 'loading') return
            this.series.status = 'loading'
            const data = {
                clientId: this.clientId,
                productCode: this.selectedProduct.productCode,
                seriesSearch: this.seriesSearch || null,
                orderCode: this.orderCode,
                page: 1,
                itemsPerPage: 50
            }
            this.axios({url: 'api/v1/claim/searchproductsforclaim', data: data, method: 'POST'})
                .then(resp => {
                    this.series.status = ''
                    this.series.list = resp.data.series || []
                }).catch(() => {
                    this.series.status = ''
                })
        },
        selectProduct (item) {
            this.selectedProduct = item
        },
        selectSeries (item) {
            this.selectedSeries = item
        },
        goToSeries () {
            if (!this.selectedProduct) return
            this.activeTab = 'series'
            this.selectedSeries = null
            this.series.list = []
            this.searchSeries()
        },
        confirmSelection () {
            if (!this.selectedProduct || !this.selectedSeries) return
            const result = {
                productCode: this.selectedProduct.productCode,
                seriesNumber: this.selectedSeries.seriesNumber || '',
                name: `[${this.selectedSeries.seriesNumber || ''}] ${this.selectedProduct.productName}`
            }
            if (this.activePopup && this.activePopup.callback) {
                this.activePopup.callback(result)
            }
            this.$emit('closePopup')
        }
    },
    mounted () {
    }
}
</script>

<style lang="scss" scoped>
.search-product-tabs {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
    border-bottom: 2px solid #e0e0e0;

    .tab {
        padding: 10px 0;
        cursor: pointer;
        border-bottom: 3px solid transparent;
        margin-bottom: -2px;

        &.active {
            border-bottom-color: #8AC148;
            font-weight: 600;
        }

        &.disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }
    }
}

.search-product-hint {
    margin-bottom: 16px;
    font-size: 13px;
    color: #666;
}

.search-product-table {
    margin-top: 20px;
    margin-bottom: 16px;

    table {
        width: 100%;
        border-collapse: collapse;

        thead td {
            font-weight: 600;
            padding: 10px;
            border-bottom: 1px solid #e0e0e0;
        }

        tbody tr {
            cursor: pointer;
            border-bottom: 1px solid #f0f0f0;

            &:hover {
                background: #f8f8f8;
            }

            &.active {
                background: #e8f5e0;
            }

            td {
                padding: 10px;
            }
        }
    }
}

.search-product-footer {
    padding: 12px 20px 20px;
    border-top: 1px solid #e0e0e0;
    background: #fff;
    flex-shrink: 0;
}

.search-product-summary {
    font-size: 13px;
    color: #666;
    margin-bottom: 12px;
}

.search-product-actions {
    display: flex;
    gap: 12px;
}

.search-product-selected {
    margin-bottom: 20px;
    padding: 12px;
    background: #f5f5f5;
    border-radius: 8px;

    .claim-text {
        margin-bottom: 4px;

        span {
            margin-right: 6px;
            color: #666;
        }
    }
}
</style>
